var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contenedor-listado-desktop"}},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.listado,"items-per-page":20},scopedSlots:_vm._u([{key:"item.fechaNombramiento",fn:function(ref){
var item = ref.item;
return [_c('fecha-humano',{attrs:{"fecha":new Date(item.fechaNombramiento)}})]}},{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('opciones',{attrs:{"funcionario":item}})]}},{key:"item.esSupervisor",fn:function(ref){
var item = ref.item;
return [(item.esSupervisor)?_c('v-icon',{staticClass:"amber--text"},[_vm._v("\n        fa-hard-hat\n      ")]):_vm._e()]}},{key:"item.createdAt",fn:function(ref){
var item = ref.item;
return [_c('fecha-humano',{attrs:{"fecha":new Date(item.createdAt)}})]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }